/* global window */

import merge from 'lodash/merge';

const settings = merge(
  {
    playerClass: 'hearstPlayer',
    dataAttributePrefix: 'data',
    loadedClass: 'playerLoaded',
    timeout: 10000,
    nitehawkBaseUrl: 'https://stage-nitehawk.hearst.io',
    scripts: ['https://imasdk.googleapis.com/js/sdkloader/ima3.js'],

    adSettings: {
      adsRenderingSettings: {
        loadVideoTimeout: 10000,
      },
      contribAdsSettings: {
        timeout: 10000,
        prerollTimeout: 1000,
      },
    },

    // Playlist auto-advance settings.
    enableAutoAdvance: true,
    autoAdvanceDelayInSeconds: 0,

    // Sample sharing options
    sharingOptions: {
      // disable twitter and facebook by default
      socials: [],
    },

    enableQualityLevels: true,
  },
  window.playerSettings,
);

export default settings;



// WEBPACK FOOTER //
// ./node_modules/video-js-core/src/settings.js